import Actor from "../../actors/Actor";

export default class Oven extends Actor {
    constructor() {
        super();

        this.view = new PIXI.spine.Spine(P3.assets.spineData('oven'));
        this.view.position.set(0);
        this.view.scale.set(0.5);
        this.view.skeleton.setToSetupPose();
        this.view.skeleton.setSkin(null);
        this.view.skeleton.setSkinByName("default");
        this.view.autoUpdate = false;
        this.view.update(0);
        this.addChild(this.view);
        this.view.stateData.defaultMix = 0.2;

        this.view.state.addListener({
            complete: this._onAnimationComplete.bind(this),
            event: this._onAnimationEvent.bind(this)
        });

        this._ovenClosed = new P3.utils.MiniSignal();
        this._ovenOpened = new P3.utils.MiniSignal();
    }

    playOpenOven(){
        this.view.state.addAnimation(0, "open_oven", false, 0);
    }

    playCloseOven(){
        this.view.state.addAnimation(0, "close_oven", false, 0);
    }


    update(dt) {
        this.view.update(dt);
    }

    _onAnimationComplete(entry) {
        const name = entry.animation.name;
        if (["close_oven"].indexOf(name) !== -1) {
            this._ovenClosed.dispatch();
        }
        if (["open_oven"].indexOf(name) !== -1) {
            this._ovenOpened.dispatch();
        }
    }

    _onAnimationEvent(entry, event) {
    }
}